<template>
    <div class="alipay-container">
        <div v-if="browser.browser().wechat">
            <div class="alipay-row-img">
                <img style="height:25vh;width: 40vw" :src="images.alipay_3"/>
            </div>
            <div class="alipay-row">
                <span>1、点击右上角“</span>
                <img style="border-radius: 24px;height: 24px" :src="images.alipay_2"/>
                <span>”</span>
            </div>
            <div class="alipay-row">
                <span>2、选择“</span>
                <img style="height: 32px" :src="images.alipay_0"/>
                <span>在浏览器中打开”</span>
            </div>
            <div class="alipay-row">
                <span>3、跳转至支付宝完成支付</span>
            </div>
            <div class="alipay-row">
                <span>4、点击下方按钮即可查看内容</span>
            </div>
            <div style="display: flex;margin-top: 30px; justify-content: center">
                <van-button type="primary" @click="payOk">支付成功后，点此看内容</van-button>
            </div>
        </div>
        <div v-else>

        </div>

    </div>
</template>
<script>
    import alipay_0 from '@/assets/alipay_0.png'
    import alipay_2 from '@/assets/alipay_2.jpg'
    import alipay_3 from '@/assets/alipay_3.png'
    export default {
        name: 'alipay',
        data() {
            return {
                guide: false,
                images: {
                    alipay_0: alipay_0,
                    alipay_2: alipay_2,
                    alipay_3: alipay_3,
                },
            }
        },
        created:function () {
            this.params = this.weutil.getParams(window.location.href);
            this.guide = this.params.guide
            if(!this.browser.browser().wechat && this.params.uid && this.params.app_id && this.params.project_id){
                this.alipay()
            }
        },
        methods:{
            payOk:function(){
                this.$router.go(-1);
            },
            alipay:function () {
                let that = this
                this.weapi.request({
                    url: 'pay/alipay/project_with_uid',
                    method: 'get',
                    params: {
                        app_id: this.params.app_id,
                        project_id: this.params.project_id,
                        uid:this.params.uid,
                        redirect_url:window.location.href
                    },
                }).then(res => {
                    if (res.status === 200) {
                        const div = document.createElement('div')
                        /* 此处form就是后台返回接收到的数据 */
                        div.innerHTML = res.data
                        document.body.appendChild(div)
                        document.forms[0].submit()
                    }
                    else if(res.status === 202){
                        that.$toast(res.data);
                    }
                    else {

                    }
                }).catch(function (error) {
                    console.log(error)
                    that.$toast('系统错误，请稍后重试！');
                }).finally(function (response) {
                })

            }
        }
    }
</script>
<style>
    .alipay-container{
        display: flex;
        flex-direction: column;
        width: calc(100vw);
        height: calc(100vh);
        background-color: rgba(0,0,0,0.5);
    }
    .alipay-row-img{
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: center;
    }
    .alipay-row{
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        margin: 15px 0 15px 30px;
    }
    .alipay-row span{
        font-size: 18px;
        color: #fff;
        margin: 0 10px;
    }
</style>
